<div class="card">
  <div class="card-header-white header-underline">
    <h6 class="white-header-text">
      @if (isAddMode) {
        {{ "NEW_CAMERA_GROUP" | translate }}
      }
      @if (isEditMode) {
        {{ "EDIT_CAMERA_GROUP" | translate }}
        <strong>{{ existingGroup?.displayName }}</strong>
      }
    </h6>
    <span class="float-right cursorPointer" (click)="showForm.next(false)">
      <span class="fa-light fa-xmark white-header-xmark-icon"></span>
    </span>
  </div>

  @if (cameraGroupForm) {
    <form class="form" [style.min-height]="isEditMode ? '700px' : 'auto'">
      @if (hasNightowlDevices || isEditMode) {
        <div class="form-group row mt-2">
          <label class="col-sm-2 mt-1" for="device-type"><strong>{{ "DEVICE_TYPE" | translate }}:</strong></label>
          <select name="device_type" id="device-type" class="form-control form-control-sm col-sm-4 selectBgImage"
            [(ngModel)]="selectedDeviceType"
            [disabled]="isEditMode || cameraGroupForm.cameras.length > 0"
            (change)="onDeviceTypeSelectChange()"
            [ngModelOptions]="{standalone: true}">
            <option value="Camera">
              {{ "Digital Supervision" | translate }} (VL-201)
            </option>
            <option value="Nightowl">
              Nightowl (PS-101)
            </option>
          </select>
        </div>
      }
      <div class="form-group row mt-2">
        <label class="col-sm-2 mt-1" for="displayName"><strong>{{ "GROUP_NAME" | translate }}:</strong></label>
        <input
          type="text"
          [(ngModel)]="cameraGroupForm.displayName"
          name="displayName"
          id="displayName"
          [attr.data-testid]="isEditMode ? 'displayName' : null"
          class="form-control form-control-sm col-sm-4"
          [ngClass]="{ 'is-invalid': !displayName.value, 'is-valid': displayName.value }"
          [required]="isEditMode"
          #displayName="ngModel" />
          <div class="col">
            <p class="float-right">
              <strong>{{ "TIME_ZONE" | translate }}</strong>: {{ cameraGroupForm.timeZone }}
            </p>
          </div>
        </div>
        <div class="form-group row mt-2">
          <label class="col-sm-2 mt-1" for="address"><strong>{{ "ADDRESS" | translate }}:</strong></label>
          <input
            type="text"
            [(ngModel)]="cameraGroupForm.address"
            name="address"
            id="address"
            class="form-control form-control-sm col-sm-4"
            [ngClass]="{ 'is-valid': cameraGroupForm.address }" />
          </div>
          <div class="form-group row mt-2">
            <label class="col-sm-2 mt-1" for="postCode"><strong>{{ "POSTCODE" | translate }}:</strong></label>
            <input
              type="text"
              [(ngModel)]="cameraGroupForm.postCode"
              name="postCode"
              id="postCode"
              class="form-control form-control-sm col-sm-4"
              [ngClass]="{ 'is-valid': cameraGroupForm.postCode }" />
            </div>
            <div class="form-group row mt-2">
              <label class="col-sm-2 mt-1" for="city"><strong>{{ "POSTOFFICE" | translate }}:</strong></label>
              <input
                type="text"
                [(ngModel)]="cameraGroupForm.postOffice"
                name="city"
                id="city"
                class="form-control form-control-sm col-sm-4"
                [ngClass]="{ 'is-valid': cameraGroupForm.postOffice }" />
              </div>
              <div class="form-group row" [ngClass]="{'mt-2': isEditMode}">
                <label class="col-sm-2 mt-1" for="location"><strong>{{ "LOCATION" | translate }}:</strong></label>
                <select
                  name="location"
                  id="location"
                  class="form-control form-control-sm col-sm-4 selectBgImage"
                  [ngClass]="{ 'is-invalid': cameraGroupForm?.locationId?.length === 0, 'is-valid': $safeNavigationMigration(cameraGroupForm?.locationId?.length) > 0 }"
                  [(ngModel)]="selectedLocation"
                  (change)="onLocationSelectChange()">
                  @if (isAddMode) {
                    <option [value]="undefined" selected>-</option>
                  }
                  @for (location of locationSelect; track location) {
                    <option
                      [ngValue]="location">
                      {{ location.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="form-group row" [ngClass]="{'mt-2': isEditMode}">
                <label class="col-sm-2 mt-1" for="accessMode"><strong>{{ "ACCESS_MODE" | translate }}:</strong></label>
                <select
                  name="accessMode"
                  id="accessMode"
                  class="form-control form-control-sm col-sm-4"
                  [(ngModel)]="cameraGroupForm.accessMode"
                  (change)="onAccessModeChange()">
                  @if (isAddMode) {
                    <option [value]="undefined">
                      {{ "SCHEDULED_VISIT" | translate }}
                    </option>
                    <option value="visitOnAlert">
                      {{ "VISIT_ON_ALERT" | translate }}
                    </option>
                    @if (selectedDeviceType !== 'Nightowl') {
                      <option value="always">
                        {{ "ACCESS_MODE_ALWAYS" | translate }}
                      </option>
                    }
                  }
                  @if (isEditMode) {
                    @if (existingGroup?.deviceType !== 'Nightowl') {
                      <option value="always">
                        {{ "ACCESS_MODE_ALWAYS" | translate }}
                      </option>
                    }
                    <option value="visitOnAlert">
                      {{ "VISIT_ON_ALERT" | translate }}
                    </option>
                    <option [value]="undefined">
                      {{ "SCHEDULED_VISIT" | translate }}
                    </option>
                  }
                </select>
              </div>
              <!-- Origon section -->
              @if (selectedDeviceType !== 'Nightowl') {
                <div class="row mb-5">
                  <div class="col-5">
                    <label class="mb-1" for="origonCall"><strong>{{ "ORIGON_CALL" | translate }}:</strong></label>
                    <app-multiselect-dropdown
                      class="multiselect-dropdown"
                      [placeholder]="'ORIGON_CALL' | translate"
                      [groupedOptions]="origonsOfLocation"
                      [disabled]="!cameraGroupForm.locationId"
                      [enableSearch]="true"
                      (selectedChange)="onOrigonSelectedChange($event)"
                      [selected]="selectedOrigonId ? [selectedOrigonId] : []">
                    </app-multiselect-dropdown>
                  </div>
                </div>
              }
              <!-- If scheduled visit add toggle for pause-->
              @if (isEditMode && cameraGroupForm.accessMode === undefined) {
                <div class="form-group row mt-2">
                  <label class="col-sm-2 mt-1" style="position: relative;">
                    <i
                      class="fa-solid fa-circle-info"
                      style="cursor: help; position: absolute; top: -8px; right: 10px; font-size: 0.9em;"
                      [matTooltip]="'PAUSE_TOGGLE_TOOLTIP' | translate"
                      #pauseToggleTooltip="matTooltip"
                      matTooltipPosition="right"
                      matTooltipTouchGestures="auto"
                    (click)="pauseToggleTooltip.show()"></i>
                    <strong>{{ "PAUSE_CAMERA_GROUP" | translate }}:</strong>
                  </label>
                  <label class="switch mb-0" style="transform: scale(0.7); transform-origin: left;">
                    <input
                      type="checkbox"
                      [(ngModel)]="cameraGroupForm.isPaused"
                      name="isPaused"
                      id="isPaused"
                      (ngModelChange)="onPauseToggleChange()"
                      [ngModelOptions]="{standalone: true}" />
                      <span class="slider round"></span>
                    </label>
                  </div>
                }
                <!-- Pause schedule form - shown when isPaused is true -->
                @if (isEditMode && cameraGroupForm.accessMode === undefined && cameraGroupForm.isPaused) {
                  <div class="mb-4">
                    <div class="form-group row mt-3">
                      <label class="col-sm-2"><strong>{{ "PAUSE_TIME" | translate }}:</strong></label>
                      <input
                        type="date"
                        class="form-control form-control-sm col-sm-2 mr-2"
                        [ngClass]="{'is-invalid': isPauseStartInvalid}"
                        name="pauseStartDate"
                        id="pauseStartDate"
                        [min]="todayDateString"
                        [(ngModel)]="pauseStartDate"
                        (ngModelChange)="onPauseDateTimeChange()"
                        [ngModelOptions]="{standalone: true}" />
                        <input
                          type="time"
                          class="form-control form-control-sm col-sm-2"
                          [ngClass]="{'is-invalid': isPauseStartInvalid}"
                          name="pauseStartTime"
                          id="pauseStartTime"
                          [(ngModel)]="pauseStartTime"
                          (ngModelChange)="onPauseDateTimeChange()"
                          [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="form-group row mt-2">
                          <label class="col-sm-2"><strong>{{ "RESUME_AT" | translate }}:</strong></label>
                          <input
                            type="date"
                            class="form-control form-control-sm col-sm-2 mr-2"
                            [ngClass]="{'is-invalid': isResumeAtInvalid}"
                            name="resumeDate"
                            id="resumeDate"
                            [min]="todayDateString"
                            [(ngModel)]="resumeDate"
                            (ngModelChange)="onPauseDateTimeChange()"
                            [ngModelOptions]="{standalone: true}" />
                            <input
                              type="time"
                              class="form-control form-control-sm col-sm-2"
                              [ngClass]="{'is-invalid': isResumeAtInvalid}"
                              name="resumeTime"
                              id="resumeTime"
                              [(ngModel)]="resumeTime"
                              (ngModelChange)="onPauseDateTimeChange()"
                              [ngModelOptions]="{standalone: true}" />
                            </div>
                            <div class="form-group row" style="margin-top: -15px;">
                              <div class="col-sm-2"></div>
                              <div class="col-sm-4">
                                <p class="form-text text-muted mb-0">
                                  <small>
                                    {{ "MIN_DURATION" | translate }}
                                    <a href="javascript:void(0)" class="text-primary ml-4" (click)="clearPauseSchedule()">
                                      {{ "CLEAR_SCHEDULE" | translate }}
                                    </a>
                                  </small>
                                </p>
                              </div>
                            </div>
                            @if (pauseScheduleError && arePauseTimesComplete()) {
                              <div class="form-group row">
                                <div class="col-sm-2"></div>
                                <div class="col-sm-3">
                                  <div class="alert alert-danger mb-0 py-1 px-2" role="alert">
                                    <small>{{ pauseScheduleError | translate }}</small>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <br />
                        <br />
                        <div class="section">
                          <div class="row mb-5">
                            <div class="col-5">
                              <p class="mb-1"><strong>{{ "RECEIVER_TEAMS" | translate }}:</strong></p>
                              <app-multiselect-dropdown
                                class="multiselect-dropdown"
                                [placeholder]="'RECEIVER_TEAM' | translate"
                                [groupedOptions]="receiverTeamSelect"
                                [enableSearch]="true"
                                [disabled]="!cameraGroupForm.locationId"
                                [(selected)]="cameraGroupForm.userGroups"
                              ></app-multiselect-dropdown>
                            </div>
                            <div class="col">
                              @if (cameraGroupForm.userGroups.length > 0) {
                                <strong>{{ "SELECTED_RECEIVER_TEAMS" | translate }}:</strong>
                                <div class="bordered-box mt-1">
                                  <ul class="mb-0">
                                    @for (userGroupId of cameraGroupForm.userGroups; track userGroupId) {
                                      <li>
                                        {{ userGroupId | receiverTeamName : receiverTeamSelect }}
                                      </li>
                                    }
                                  </ul>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="section pt-2">
                          <app-select-cameras
                            [cameras]="cameraGroupForm.cameras"
                            [camerasOfLocation]="camerasOfLocation"
                            [cameraList]="cameraList"
                            [disabled]="cameraSelectDisabled"
                            [selectedLocation]="selectedLocation"
                            [accessMode]="cameraGroupForm.accessMode"
                            [deviceType]="cameraGroupForm.deviceType"
                            (cameraSelectChange)="onCameraSelectChange($event)"
                            (visitWithAlertToggle)="onVisitWithAlertToggle($event)">
                          </app-select-cameras>
                          <br />
                        </div>
                        @if ((isAddMode || (isEditMode && visitConfigForm)) && (cameraGroupForm.accessMode === 'visitOnAlert' || isScheduledNightowlWithAlertSources())) {
                          @if (cameraGroupForm.accessMode === 'visitOnAlert') {
                            <div class="section pb-2">
                              <div class="row">
                                <div class="col-5">
                                  <p class="mb-1"><strong>{{ "DEVICES_TO_TRIGGER_ALERT" | translate }}:</strong></p>
                                  @if (isAddMode || (isEditMode && alertDeviceSelect?.length > 0)) {
                                    <app-multiselect-dropdown
                                      class="multiselect-dropdown"
                                      [placeholder]="'SELECT_DEVICES' | translate"
                                      [options]="alertDeviceSelect"
                                      [enableSearch]="true"
                                      (selectedChange)="parseSelectedDevices($event)"
                                      [(selected)]="selectedAlertDevices"
                                    ></app-multiselect-dropdown>
                                  }
                                </div>
                                <div class="col">
                                  @if (visitConfigForm?.alertSources?.length > 0) {
                                    <strong>{{ "SELECTED_DEVICES" | translate }}:</strong>
                                    <div class="bordered-box mt-1">
                                      <ul class="mb-0">
                                        @for (obj of visitConfigForm.alertSources; track obj) {
                                          <li>
                                            {{ obj.deviceID | deviceName : alertDeviceSelect }}
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          @if (selectedDeviceType === 'Nightowl' && visitConfigForm?.alertSources?.length > 0 && availableAlarmTypes.length > 0) {
                            <div class="section pb-2">
                              <div class="row">
                                <div class="col-5">
                                  <p class="mb-1"><strong>{{ "ACTIVATIONS" | translate }}:</strong></p>
                                  <app-multiselect-dropdown
                                    class="multiselect-dropdown"
                                    [placeholder]="'ACTIVATIONS' | translate"
                                    [groupedOptions]="alarmTypeSelect"
                                    [enableSearch]="true"
                                    (selectedChange)="parseSelectedAlarmTypes($event)"
                                    [(selected)]="selectedAlarmTypes"
                                  ></app-multiselect-dropdown>
                                </div>
                              </div>
                            </div>
                          }
                          @if (selectedDeviceType !== 'Nightowl') {
                            <div class="section">
                              <strong>{{ "LENGTH_OF_VISIT" | translate }}:</strong>
                              <div class="row mx-0 mt-4 pb-4">
                                <div class="form-group">
                                  <label for="visitTime">
                                    <strong>{{ "VISIT_TIME" | translate }}</strong>
                                  </label>
                                  <div class="d-flex">
                                    <input
                                      name="visitTime"
                                      type="number"
                                      [(ngModel)]="visitConfigForm.options.visitTimeMinutes"
                                      [max]="visitTimeMax"
                                      (change)="validateVisitTimeInput($event.target.value, 0)"
                                      class="form-control form-control-sm"
                                      min="0"
                                      id="visitTime"
                                      style="width: 100px" />
                                      <div class="mt-1 mr-2">
                                        <div class="row">
                                          <i
                                            class="fa-solid fa-caret-up"
                                            style="margin-bottom: -3px"
                                            [style.visibility]="visitConfigForm.options.visitTimeMinutes >= visitTimeMax ? 'hidden' : 'visible'"
                                            (click)="setCount(visitConfigForm.options.visitTimeMinutes + 1, 0)">
                                          </i>
                                        </div>
                                        <div class="row">
                                          <i
                                            class="fa-solid fa-caret-down"
                                            (click)="setCount(visitConfigForm.options.visitTimeMinutes - 1, 0)">
                                          </i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group ml-5">
                                    <label for="visitGraceTime"><strong>{{ "GRACE_TIME" | translate }}</strong></label>
                                    <div class="d-flex">
                                      <input
                                        type="number"
                                        [(ngModel)]="visitConfigForm.options.visitGraceTimeMinutes"
                                        [disabled]="graceTimeDisabled"
                                        (change)="validateVisitTimeInput($event.target.value, 1)"
                                        class="form-control form-control-sm"
                                        min="0"
                                        id="visitGraceTime"
                                        name="visitGraceTime"
                                        style="width: 100px" />
                                        <div class="mt-1 mr-2">
                                          <div class="row">
                                            <i
                                              class="fa-solid fa-caret-up"
                                              style="margin-bottom: -3px"
                                              [style.visibility]="graceTimeDisabled ? 'hidden' : 'visible'"
                                              (click)="setCount(visitConfigForm.options.visitGraceTimeMinutes + 1, 1)">
                                            </i>
                                          </div>
                                          <div class="row">
                                            <i
                                              class="fa-solid fa-caret-down"
                                              [style.visibility]="graceTimeDisabled ? 'hidden' : 'visible'"
                                              (click)="setCount(visitConfigForm.options.visitGraceTimeMinutes - 1, 1)">
                                            </i>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            }
                            <!-- Add mode specific warnings -->
                            @if (isAddMode && !isNightowlServiceCustomerIdSet && selectedDeviceType === 'Nightowl') {
                              <div
                                class="alert alert-danger"
                                style="width: fit-content"
                                role="alert">
                                {{ "NIGHTOWL_CUSTOMER_ID_NOT_SET" | translate }}
                              </div>
                            }
                            @if (hasDifferentNightowlCustomerIdsSelected()) {
                              <div
                                class="alert alert-danger mt-2"
                                style="width: fit-content"
                                role="alert">
                                {{ "NIGHTOWL_MULTIPLE_CUSTOMER_IDS_WARNING" | translate }}
                              </div>
                            }
                            <hr />
                            @if (origonGsmNumberMissing) {
                              <div
                                class="alert alert-danger"
                                style="width: fit-content"
                                role="alert">
                                {{ "ORIGON_GSM_NUMBER_NOT_SET" | translate }}
                              </div>
                            }
                            @if (showSubmitErrorMsg) {
                              <div
                                class="alert alert-danger"
                                style="width: fit-content"
                                role="alert"
                                [attr.fadeOut]="isEditMode ? '' : null">
                                {{ submitErrorMessage | translate }}
                              </div>
                            }
                            <!-- Paused visits information -->
                            @if (isEditMode && cameraGroupForm.accessMode === undefined && cameraGroupForm.isPaused && showPausedVisitsInfo && arePauseTimesComplete()) {
                              <div class="alert alert-warning mb-3" style="width: fit-content" role="alert">
                                @if (!loadingVisitsCount && pausedVisitsCount > 0) {
                                  <div>
                                    <i class="fa fa-exclamation-triangle mr-2"></i>
                                    @if (pausedVisitsMessage === 'PAUSED_VISITS_SINGULAR') {
                                      <span>
                                        {{ pausedVisitsCount }} {{ "VISIT_TO_BE_PAUSED" | translate }}
                                      </span>
                                    }
                                    @if (pausedVisitsMessage === 'PAUSED_VISITS_PLURAL') {
                                      <span>
                                        {{ pausedVisitsCount }} {{ "VISITS_TO_BE_PAUSED" | translate }}
                                      </span>
                                    }
                                  </div>
                                }
                                @if (!loadingVisitsCount && pausedVisitsCount === 0) {
                                  <div>
                                    <i class="fa fa-info-circle mr-2"></i>
                                    {{ "NO_VISITS_TO_PAUSE" | translate }}
                                  </div>
                                }
                              </div>
                            }
                            <div class="row pb-3" [style.width]="isEditMode ? '103%' : '100%'">
                              <div class="col">
                                @if (isAddMode) {
                                  <button
                                    type="submit"
                                    class="btn btn-primary mr-3"
                                    [disabled]="disableSubmitButton()"
                                    appThrottleClick
                                    (throttledClick)="submit()">
                                    <span class="fa-light fa-floppy-disk"></span>{{ "SAVE" | translate }}
                                  </button>
                                }
                                @if (isEditMode) {
                                  <button
                                    type="submit"
                                    class="btn btn-primary mr-3"
                                    [disabled]="disableSubmitButton()"
                                    (click)="validateAndUpdate(confirmVisitsClearDialog)">
                                    <span [ngClass]="waitingResponse ? 'fad fa-spinner-third fa-spin mr-2' : 'fa-light fa-floppy-disk'"></span>
                                    {{ (waitingResponse ? "SAVING" : "SAVE") | translate }}
                                  </button>
                                }
                                <button
                                  type="button"
                                  class="btn btn-outline-dark"
                                  (click)="showForm.next(false)">
                                  <span class="fa-light fa-times"></span>
                                  {{ "CANCEL" | translate }}
                                </button>
                              </div>
                              @if (isEditMode) {
                                <div class="col">
                                  <button
                                    class="warningBtnLessAttention float-right"
                                    (click)="openDialog(confirmDeleteDialog, { centered: true })">
                                    <span class="fa-light fa-trash-alt"></span>
                                    {{ "DELETE" | translate }}
                                  </button>
                                </div>
                              }
                            </div>
                          </form>
                        }
                      </div>

                      <!-- Edit mode dialogs -->
                      <!-- Clear visits on update info dialog -->
                      <ng-template #confirmVisitsClearDialog let-modal>
                        <div class="modal-header">
                          <h2 class="text-warning">{{ "WARNING" | translate }}!</h2>
                          <span class="float-right cursorPointer" (click)="modal.dismiss()">
                            <span class="fa-sharp fa-solid fa-x"></span>
                          </span>
                        </div>

                        <div class="border rounded mx-3 mb-3 px-2 pt-2">
                          <p class="fs-16">{{ "CLEAR_VISITS_ON_CONFIRM_DESCRIPTION" |translate }}</p>

                          <div class="my-3">
                            <p class="fs-16"><strong>{{ "FOLLOWING_VISIT_AFFECTING_CHANGES_WERE_MADE" | translate }}:</strong></p>

                            <div id="modifiedFieldsContainer" class="mt-4">
                              @if (visitAffectingChanges?.removedCameras?.length > 0) {
                                <span class="d-flex flex-wrap align-items-center pb-4">
                                  <span class="mr-3 mb-2">{{ "REMOVED/CHANGED_CAMERAS" | translate }}:</span>
                                  @for (removedCamera of visitAffectingChanges.removedCameras; track removedCamera; let last = $last) {
                                    <span class="negative-highlight ml-1 mb-2">
                                      <strong>
                                        {{ removedCamera }}
                                      </strong>
                                    </span>
                                    @if (!last) {
                                      <strong class="mb-2">,</strong>
                                    }
                                  }
                                </span>
                              }

                              @if (visitAffectingChanges?.removedReceiverTeams?.length > 0) {
                                <span class="d-flex flex-wrap align-items-center pb-4">
                                  <span class="mr-3 mb-2">{{ "REMOVED/CHANGED_RECEIVER_TEAMS" | translate }}:</span>
                                  @for (removedGroup of visitAffectingChanges.removedReceiverTeams; track removedGroup; let last = $last) {
                                    <span class="negative-highlight ml-1 mb-2">
                                      <strong>
                                        {{ removedGroup }}
                                      </strong>
                                    </span>
                                    @if (!last) {
                                      <strong class="mb-2">,</strong>
                                    }
                                  }
                                </span>
                              }

                              @if (visitAffectingChanges.accessModeChange) {
                                <span class="d-flex flex-wrap align-items-center pb-4">
                                  <span class="mr-3 mb-2">{{ "ACCESS_MODE_CHANGED" | translate }}:</span>
                                  <span class="positive-highlight line-through mb-2">
                                    <strong>{{ "SCHEDULED_VISIT" | translate }}</strong>
                                  </span>
                                  <i class="fa-light fa-arrow-right-long fa-lg mx-3 mb-2"></i>
                                  <span class="negative-highlight mb-2">
                                    <strong>{{ visitAffectingChanges.accessModeChange | translate }}</strong>
                                  </span>
                                </span>
                              }
                            </div>
                          </div>
                        </div>

                        @if (!dialogErrorMsg) {
                          <h5 class="ml-3 mb-3">
                            <strong class="irreversibleActionWarning">
                              {{ "ACTION_CANT_BE_UNDONE" | translate }}
                            </strong>
                          </h5>
                        }

                        @if (dialogErrorMsg) {
                          <div class="alert alert-danger mb-3" id="dialogErrorMsg" role="alert">
                            {{ dialogErrorMsg | translate }}
                          </div>
                        }

                        <div class="btnRow mb-3">
                          <button
                            type="button"
                            class="btn btn-primary confirmBtn float-left"
                            (click)="clearVisitsAndUpdateGroup()"
                            >
                            <span [ngClass]="{ 'fad fa-spinner-third fa-spin mr-2': waitingResponse }"></span>
                            {{ (waitingResponse ? "PROCESSING" : "CONFIRM") | translate }}
                          </button>

                          <button
                            type="button"
                            class="btn btn-secondary cancelDeleteBtn float-right"
                            (click)="modal.dismiss()">
                            {{ "CANCEL" | translate }}
                          </button>
                        </div>
                      </ng-template>

                      <!-- Delete dialog -->
                      <ng-template #confirmDeleteDialog let-modal>
                        <div class="modal-header">
                          <h2 style="color: #e8413b">{{ "WARNING" | translate }}!</h2>
                          <span class="float-right cursorPointer" (click)="modal.dismiss()">
                            <span class="fa-sharp fa-solid fa-x"></span>
                          </span>
                        </div>

                        <section class="deleteDescription">
                          <p>
                            {{ "CAMERA_GROUP_DELETE_CONFIRM" | translate }}
                            <strong>{{ existingGroup?.displayName }}</strong>
                            {{
                            (!existingGroup?.accessMode
                            ? "SCHEDULED_CAMERA_GROUP_DATA_LOSS_INFO"
                            : "CAMERA_GROUP_DATA_LOSS_TO_LOWERCASE")
                            | translate | lowercase
                            }}
                            <strong>{{ "PERMANENTLY_LOWERCASE" | translate }}</strong>.
                          </p>

                          @if (!dialogErrorMsg) {
                            <h5>
                              <strong class="irreversibleActionWarning">
                                {{ "ACTION_CANT_BE_UNDONE" | translate }}
                              </strong>
                            </h5>
                          }
                        </section>

                        @if (dialogErrorMsg) {
                          <div class="alert alert-danger" id="dialogErrorMsg" role="alert">
                            {{ dialogErrorMsg | translate }}
                          </div>
                        }

                        <div class="btnRow mb-3">
                          <button
                            type="button"
                            class="btn btn-danger deleteCardBtn float-left"
                            (click)="deleteCameraGroup()">
                            <span [ngClass]="waitingResponse ? 'fad fa-spinner-third fa-spin' : 'fa-light fa-trash-alt'"></span>
                            {{ (waitingResponse ? "DELETING" : "CONFIRM_DELETE") | translate }}
                          </button>

                          <button
                            type="button"
                            class="btn btn-secondary cancelDeleteBtn float-right"
                            (click)="modal.dismiss()">
                            {{ "CANCEL" | translate }}
                          </button>
                        </div>
                      </ng-template>
